import axiosInstance from "@/app/lib/api-client";
import { ExtendedAPIParams, Organization } from "@/app/lib/definitions";
import { OrganizationContextData } from "@/app/lib/definitions/organization";
import { PaginatedResponse } from "@/app/lib/hooks/usePaginatedQuery";

export const getOrganizations = (params: ExtendedAPIParams = {}) =>
  axiosInstance
    .get<PaginatedResponse<Organization>>("/organizations/", { params })
    .then((response) => response.data);

export const createOrganization = (formData: Partial<Organization>) =>
  axiosInstance.post<Organization>("/organizations/", formData).then((response) => response.data);

export const getOrganizationContext = (): Promise<OrganizationContextData> =>
  axiosInstance.get("/organizations/context/").then((response) => response.data);

export const patchOrganizationSettings = (data: Partial<OrganizationContextData["settings"]>) =>
  axiosInstance.patch("/organizations/settings/", data).then((response) => response.data);
